import { deleteFamilyMemberInsurancePolicy } from 'core'

import { Modal, Notification } from 'common/components'
import { useCommandRequestV2 } from 'common/hooks'

type RemoveDependantModalProps = {
  visible: boolean
  dependentPolicyId: string
  onCancel: () => void
  onSubmit: () => void
}

const RemoveDependantModal = ({ visible, dependentPolicyId, onCancel, onSubmit }: RemoveDependantModalProps) => {
  const { sendCommand: sendDeleteDependentPolicy, isLoading: isRemoveDependentPolicyLoading } = useCommandRequestV2(
    (id: string) => deleteFamilyMemberInsurancePolicy(id),
  )

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      title="Are you sure you want to remove this dependent?"
      okText="Remove"
      onOk={async () => {
        const result = await sendDeleteDependentPolicy(dependentPolicyId)
        if (result.completed) {
          onCancel()
          onSubmit()
          Notification.open({
            message: 'Dependent removed successfully',
            type: 'success',
          })
        }
      }}
      okButtonProps={{ danger: true, loading: isRemoveDependentPolicyLoading }}
    >
      <p>Doing so will remove this dependent from their benefit for the remainder of this year</p>
    </Modal>
  )
}

export default RemoveDependantModal
